import cx from 'clsx';
import React, { useState } from 'react';

import { ReactComponent as AccordionArrowIcon } from '@assets/svg/ic-chevron.svg';

import style from './style.module.scss';

interface IProps {
  title: string | React.ReactElement;
  count?: string;
  isOpen?: boolean;
  isNested?: boolean;
  children?: React.ReactElement;
  variant?: string;
  afterChangeShowContent?: (value: boolean) => void;
}

const Accordion: React.FC<IProps> = ({
  title,
  count,
  isOpen = false,
  isNested = false,
  children,
  variant,
  afterChangeShowContent,
}) => {
  const [showContent, setShowContent] = useState(isOpen);

  const handleShowContent = () => {
    setShowContent(!showContent);
    afterChangeShowContent && afterChangeShowContent(!showContent);
  };

  if (!children) {
    return null;
  }

  return (
    <div className={cx({ [style.isNestedAccordion]: isNested })}>
      <div
        className={cx(style.accordionPanel, {
          [style.accordionPanelOpen]: showContent,
          [style.accordionPanelNested]: isNested,
          [style.accordionPanelBordered]: variant === 'bordered',
        })}
        onClick={handleShowContent}
      >
        <AccordionArrowIcon
          className={cx(style.accordionArrow, { [style.accordionArrowOpen]: showContent })}
        />
        <div className={style.accordionTitle}>
          {title}
          {!!count && <span className={style.accordionTitleCount}> - {count}</span>}
        </div>
      </div>
      {showContent && (
        <div
          className={cx(style.accordionContent, {
            [style.accordionContentNested]: isNested,
            [style.accordionContentBordered]: variant === 'bordered',
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;
